import styled from 'styled-components';

export const StyledMetaverseSectionItem = styled.div`
  opacity: ${({ $placeholder}) => $placeholder ? '0': '1.0'};
  cursor: ${({ $placeholder}) => $placeholder ? 'undefined': 'pointer'};
  width: ${({ $width }) => $width ? $width : '100%'};

  .metaverse-section-item-image { 
    width: 100%;
    height: ${({ theme }) => theme.avatarSize}; 
    max-height: ${({ theme }) => theme.avatarSize};

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: scale linear 0.2s;
    }
  }

  .metaverse-section-item-time {
    width: 100%;
    margin-top: 0.5rem;
    font-family: "NeueMachina";
    font-size: 1rem;
    line-height: 1rem;
    font-weight: 400;
  }

  .metaverse-section-item-name {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 12px;
    font-family: "NeueMachina";
    font-size: 1.5em;
    line-height: 1em;
    font-weight: 700;
  }

  .metaverse-section-item-platform {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    position: absolute;
    top: 0;
    left: 0;
    .metaverse-section-item-icon {
      background: rgba(0, 0, 0, 0.36);
    }
  }
  .metaverse-section-item-platform-wrapper {
    width: 100%;
    position: relative;
  }

  .metaverse-section-item-description {
    font-family: "NeueMachina";
    font-size: 1em;
    line-height: 1.2rem;
    font-weight: 400;
  }

  .metaverse-section-item-plafrorm-name {
    height: 32px;
    text-wrap: nowrap;
    padding: 4px;
    padding-right: 8px;
    min-width: min-content;
    width: 0%;
    font-family: "NeueMachina";
    font-size: 1em;
    line-height: 1.6em;
    font-weight: 400;
    transition: width cubic-bezier(0, 0, 0.32, 1.35) 0.3s;
    background: rgba(0, 0, 0, 0.36);
  }

  .metaverse-section-item-icon {
    width: 32px;
    height: 32px;
    padding: 4px;
    img {
      width: ${({ theme }) => theme.iconSize};
      height: ${({ theme }) => theme.iconSize};
      object-fit: scale-down;
    }
  }

  .metaverse-section-item-icon-link {
    position: absolute;
    top: 0;
    right: 0;
    opacity: 0;
    transition: opacity linear 0.3s;
  }

  .metaverse-section-item-image-border {
    position: relative;
    padding: ${({ theme }) => theme.buttonFrameWidth};
    background: transparent;
    width: 100%;
    height: 100%;
  }

  .metaverse-section-item-image-internal-border {
    padding: ${({ theme }) => theme.buttonFrameWidth};
    background: ${({ theme }) => theme.borderDark};
    width: 100%;
    height: 100%;
  }

  .metaverse-section-item-compatible-hover {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: ${({ theme }) => theme.background};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity linear 0.2s;
    font-family: "NeueMachina";
    font-size: 1rem;
    line-height: 1rem;

    img {
      width: 1.5rem;
    }
  }

  &:hover {
    .metaverse-section-item-compatible-hover {
      opacity: 1;
    }

    .metaverse-section-item-image-border {
      background: white;
    }

    .metaverse-section-item-image {
      img {
        scale: 1.2;
      }
    }
    .metaverse-section-item-name {
      color: ${({ theme }) => theme.selection};
    }

    .metaverse-section-item-platform {
      width: 100%;
    }

    .metaverse-section-item-icon-link {
      opacity: 1.0;
    }

    .metaverse-section-item-plafrorm-name {
      width: 100%;
    }
  }
`;
